import React, { createContext, useContext } from 'react'

import { type VideoPreviewResolvedSettings } from '../../blocs/useVideoPreviewSettings'

const VideoPreviewSettingsContext =
  createContext<VideoPreviewResolvedSettings | null>(null)

interface VideoPreviewSettingsProviderProps {
  children: React.ReactNode
  settings: VideoPreviewResolvedSettings
}

export const VideoPreviewSettingsProvider = ({
  children,
  settings,
}: VideoPreviewSettingsProviderProps) => {
  return (
    <VideoPreviewSettingsContext.Provider value={settings}>
      {children}
    </VideoPreviewSettingsContext.Provider>
  )
}

export const useVideoPreviewSettingsContext =
  (): VideoPreviewResolvedSettings => {
    const context = useContext(VideoPreviewSettingsContext)
    if (!context) {
      throw new Error(
        'useVideoPreviewSettingsContext must be used within VideoPreviewSettingsProvider'
      )
    }
    return context
  }
